import moment from 'moment';
import DDIRComment from './DDIRComment';

export default class WeekTable {
  constructor(data, startDate) {
    const table = [];
    if (data.length > 0) {
      let formattedData = [];
      let extraDataForMeatBuyingExport = null;

      if (Array.isArray(data) && Array.isArray(data[0])) {
        formattedData = data[0];
        extraDataForMeatBuyingExport = data[1];
      } else {
        formattedData = data;
      }

      formattedData.forEach((eachTable, index) => {
        const weekData = {
          date: [],
          commentObj: {},
          week: {},
          year: {},
          data: { date: [], demand: [], ordered: [], received: [], inventory: [], sales: [] },
          manualAdjqty: [],
          meatBuyingExportData: {
            dailyShort: [],
            dailyRecDiff: [],
            dailyDemand: [],
            nextWeekOrder: null,
            inventoryCheck: null,
            inventory: null,
            inventoryDiff: null,
            lastWeekTotalDemand: null,
            lastWeekInventoryCheck: null,
            lastWeekInventory: null,
            lastWeekInventoryDiff: null,
            nextWeekOrdered: null
          }
        }
        weekData['week'] = eachTable['walmartWeek'];
        weekData['year'] = eachTable['walmartYearWk'].toString().substring(0, 4);

        if (eachTable['ddirComment'] != null) {
          weekData['commentObj'] = new DDIRComment(eachTable['ddirComment']);
        }
        else {
          weekData['commentObj'] = { id: "", userId: "", commentTxt: "", commentDate: "", legacyCmtText: "", wmtYrWkNbr: eachTable['walmartYearWk'] };
        }

        eachTable['ddirRows'].forEach(row => {
          weekData['data']['date'].push(moment(row['whseShipDate']).format('MMM D'));
          weekData['data']['demand'].push(row['demandQty']);
          weekData['data']['ordered'].push(row['orderedQty']);
          weekData['data']['received'].push(row['receivedQty']);
          weekData['data']['inventory'].push(row['inventoryQty']);
          weekData['data']['sales'].push(row['sales']);
          weekData['manualAdjqty'].push(row['inventoryAdjustment']);
          weekData['date'].push(row['whseShipDate']);
        });

        if (eachTable['ddirRows'].length === 0 && startDate) {
          for (let i = 0; i < 7; i++) {
            let date = moment(startDate).add(i + (index * 7), 'days');
            weekData['data']['date'].push(date.format('MMM D'));
            weekData['data']['demand'].push('');
            weekData['data']['ordered'].push('');
            weekData['data']['received'].push('');
            weekData['data']['inventory'].push('');
            weekData['data']['sales'].push('');
            weekData['manualAdjqty'].push('');
            weekData['date'].push(date.format('YYYY-MM-DD'));
          }
        }

        if (moment(weekData['date'][0]).isAfter(moment())) {
          delete weekData['data']['received'];
          delete weekData['data']['inventory'];
          delete weekData['data']['sales'];
        }

        if (extraDataForMeatBuyingExport !== null) {
          const weekDays = [
            'Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'
          ];

          const mapDailyObject = (obj, suffix) => {
            return weekDays.map(day => obj?.[`${day} ${suffix}`] ?? '');
          };

          const currentWeek = extraDataForMeatBuyingExport.currentWeek || {};
          weekData['meatBuyingExportData']['dailyShort'] = mapDailyObject(currentWeek['dayShort'], 'Short');
          weekData['meatBuyingExportData']['dailyRecDiff'] = mapDailyObject(currentWeek['dailyRecDiff'], 'Rec Diff');
          weekData['meatBuyingExportData']['dailyDemand'] = mapDailyObject(currentWeek['dailyDemand'], 'Demand');
          weekData['meatBuyingExportData']['inventoryCheck'] = currentWeek['inventoryCheck'] ?? null;
          weekData['meatBuyingExportData']['inventory'] = currentWeek['inventory'] ?? null;
          weekData['meatBuyingExportData']['inventoryDiff'] = currentWeek['inventoryDiff'] ?? currentWeek['difference'] ?? null;

          const lastWeek = extraDataForMeatBuyingExport.lastWeek || {};
          weekData['meatBuyingExportData']['lastWeekTotalDemand'] = lastWeek['totalDemand'] ?? null;
          weekData['meatBuyingExportData']['lastWeekInventoryCheck'] = lastWeek['inventoryCheck'] ?? currentWeek['inventoryCheck'] ?? null;
          weekData['meatBuyingExportData']['lastWeekInventory'] = lastWeek['inventory'] ?? currentWeek['inventory'] ?? null;
          weekData['meatBuyingExportData']['lastWeekInventoryDiff'] = lastWeek['inventoryDiff'] ?? currentWeek['inventoryDiff'] ?? currentWeek['difference'] ?? null;

          const nextWeek = extraDataForMeatBuyingExport.nextWeek || {};
          weekData['meatBuyingExportData']['nextWeekInventoryCheck'] = nextWeek['inventoryCheck'] ?? currentWeek['inventoryCheck'] ?? null;
          weekData['meatBuyingExportData']['nextWeekInventory'] = nextWeek['inventory'] ?? currentWeek['inventory'] ?? null;
          weekData['meatBuyingExportData']['nextWeekInventoryDiff'] = nextWeek['inventoryDiff'] ?? currentWeek['inventoryDiff'] ?? currentWeek['difference'] ?? null;
          weekData['meatBuyingExportData']['nextWeekOrdered'] = nextWeek['ordered'] ?? null;
        }

        table.push(weekData);
      });
    }
    return table;
  }

  static getDummyObj() {
    return new WeekTable([
      {
        "date": ["Sat 10/17", "Sun 10/18", "Mon 10/19", "Tues 10/20", "Wed 10/21", "Thur 10/22", "Fri 10/23"],
        "commentObj": {
          "week": 3720,
          "comment": "test comment 1"
        },
        "week": 37,
        "year": 2020,
        "data": {
          "date": ['JAN 1', 'JAN 2', 'JAN 3', 'JAN 4', 'JAN 5', 'JAN 6', 'JAN 7'],
          "demand": [350, 555, 678, 432, 590, 666, 878],
          "ordered": [345, 555, 678, 432, 567, 666, 878],
          "received": [345, 555, 678, 432, 567, 666, 878],
          "inventory": [345, 555, 678, 432, 567, 666, 878],
          "sales": [345, 555, 678, 432, 567, 666, 878]
        },
        "manualAdjqty": [0, 1, 0, 0, 1, 1, 0],
        "meatBuyingExportData": {
          "dailyShort": [0, 0, 0, 0, 0, 0, 0],
          "dailyRecDiff": [0, 0, 0, 0, 0, 0, 0],
          "dailyDemand": [0, 0, 0, 0, 0, 0, 0],
          "nextWeekOrder": 0,
          "inventoryCheck": 0,
          "inventory": 0,
          "inventoryDiff": 0,
          "lastWeekTotalDemand": 0,
          "lastWeekInventoryCheck": 0,
          "lastWeekInventory": 0,
          "lastWeekInventoryDiff": 0,
          "nextWeekOrdered": 0
        }
      }
    ])
  }
}